import styled from 'styled-components';
import { BLACK } from '@styles/colors';

// Styled components
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 18px;
  color: ${BLACK};
`;